<template>
  <div>
    <app-navbar v-if="ninja" :isOpen="opened" @toggle-menu="toggleSidebar"/>
      <div class="container-fluid">
        <main slot="content" id="content" class="content" role="main">
          <app-breadcrumbs v-if="ninja"/>
          <router-view v-on:onPresenca="onPresenca" v-on:onEAD="onEAD" ></router-view>
        </main> 
      </div>
      <span class="footer">© {{getDateYearActual()}}. FábricaInfo</span> 
  </div>
</template>

<script>

import AppNavbar from './app-navbar/AppNavbar'
import AppBreadcrumbs from './app-breadcrumbs/AppBreadcrumbs'
import Layout from 'vuestic-theme/vuestic-directives/Layout'
import { mapGetters } from 'vuex'
import router from '../../router'
import avisoDeFotos from '../ead/modal/avisodefotos'


export default {
  name: 'app-layout',

  components: {
    AppNavbar,
    AppBreadcrumbs,
    avisoDeFotos
    
  },
  directives: {
    layout: Layout,
  },
  data () {
    return {
      opened: true,
      ninja: true,
      showModal: true,
    }
  },
  methods: {
    toggleSidebar (opened) {
      this.opened = opened
    },
    getDateYearActual () {
      let dt = new Date()
      return dt.getFullYear()
    },
    onPresenca (value) {
      this.$data.ninja = value
    },
    onEAD (value) {
      this.$data.ninja = value
    }
  },
  computed: {
    ...mapGetters([
      'isLoading'
    ])
  }
}
</script>
<style>
.menu-icon-container.sidebar-none {
  background-color: red !important;
  display: none;
}
.footer{
  display: flex;
  justify-content: center;
  bottom: 10px;
}
</style>
